import { Brawler, HTTP, Map } from '../common.type';
import { FetchReturnType } from '../type';

const call = async <T>(path: string, init: RequestInit) => {
  return fetch(path, init).then((res) => {
    if (res.status !== HTTP.CODE.OK) {
      throw new Error(`Request status ${res.status.toString()}`);
    }
    return res.json();
  }) as FetchReturnType<T>;
};

const get = async <T>(path: string): Promise<T> => {
  return call<T>(path, { method: 'GET' });
};

export const getBrawlers = async (): Promise<Brawler[]> => {
  const json = sessionStorage.getItem('brawlers');
  if (json) {
    try {
      const brawlers = JSON.parse(json) as Brawler[];
      if (brawlers.length) {
        return Promise.resolve(brawlers);
      }
    } catch (err: unknown) {
      console.error(err);
    }
  }

  return get<Brawler[]>(`${process.env.PUBLIC_URL}/brawlers.json`).then(
    (res) => {
      const brawlers = res.sort((a, b) =>
        a.name < b.name ? -1 : a.name > b.name ? 1 : 0
      );
      sessionStorage.setItem('brawlers', JSON.stringify(brawlers));
      return brawlers;
    }
  );
};

export const getMaps = async (): Promise<Map[]> => {
  const json = sessionStorage.getItem('maps');
  if (json) {
    try {
      const maps = JSON.parse(json) as Map[];
      if (maps.length) {
        return Promise.resolve(maps);
      }
    } catch (err: unknown) {
      console.error(err);
    }
  }
  return get<Map[]>(`${process.env.PUBLIC_URL}/maps.json`).then((res) => {
    const maps = res.sort((a, b) =>
      a.name < b.name ? -1 : a.name > b.name ? 1 : 0
    );
    sessionStorage.setItem('maps', JSON.stringify(maps));
    return maps;
  });
};
